module.exports = __webpack_public_path__ + "img/company.bd5db0a9.png";